<template>
  <div  :class="['main-content','sn-content',heightC]">
    <el-card v-if="user.status == '2'" class="box-card">
      <div>
        <div class="vertical">
          <i  class="el-icon-warning-outline" style="color: orange"></i>
          <router-link  :to="{path:'/uac/authc'}"  style="color: orange">去认证</router-link>
        </div>
        <p class="tag" style="">企业用户请先进行账号认证，认证通过后，才可以申请云授权码</p>
      </div>
    </el-card>

    <div v-else>
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <div v-if="user.partnerFlag == '1' && partnerSnCnt < 10">
          <p style="text-align: left;margin-top: 20px">免费使用</p>
          <div class="box-card is-always-shadow">
            <el-form-item label="" class="pxy-form-item pxy-form-item-line">
              <div class="pxy-tag-label">
                <span style="width: 200px">使用免费行业伙伴授权：</span>
                <el-checkbox  v-model="form.partnerFlag" @change="changePartnerFlag($event)" ></el-checkbox>

              </div>
              <el-tag type="warning">*开通行业伙伴授权，可以免费使用授权，不可商业使用，最多可申请10个，已申请{{partnerSnCnt}}个</el-tag>
            </el-form-item>
          </div>
        </div>


        <div class="box-card clearfix" style="padding-top: 10px">

          <el-form-item label="" prop="tag">
            <div class="pxy-tag-label">
              <span>业务区分：</span>
            </div>
            <el-input placeholder="业务区分，10个字符以内，例如项目名" v-model="form.tag" style="width:300px"></el-input>
          </el-form-item>

          <el-form-item  v-for="(item, index) in (form.partnerFlag ? partnerItemList : commItemList)"
                        label="" class="pxy-form-item pxy-form-item-line">
            <div class="pxy-tag-label">
              <span>{{item.itemName}}：</span>
              <el-checkbox v-if="item.required == '1'" checked="checked" disabled :key="item.id" v-model="item.checkStatus">必选</el-checkbox>
              <el-checkbox v-else @change="changeContentHeight($event)" :key="item.id"  v-model="item.checkStatus"></el-checkbox>
            </div>
            <el-tag v-if="item.note" type="warning" v-html="item.note"></el-tag>
          </el-form-item>

        </div>

      </el-form>
      <div class="price-detail">
        <div class="item ">
          <div  v-for="(item, index) in (form.partnerFlag ? partnerItemList : commItemList)" v-if="item.checkStatus">
            <span class="title">{{item.itemName}}：</span>
            <span class="unit">￥</span>
            <span class="price">{{item.price}}</span>
            <span class="unit"> {{item.priceUnit}}</span>
          </div>
        </div>
        <div  class="item" style="">
          <el-button type="primary" class="pxy-primary" plain @click="addSn()">确认</el-button>
        </div>

      </div>
    </div>
     <!-- 通过微信扫码登录注册的用户，要求先补全用户信息再申请授权码 -->
    <el-dialog :visible.sync="inforSupplementVisible" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" @close="inforSupplementClose">
      <p style="margin: 0 0 50px 0; font-size: 16px; margin-left: 100px;">温馨提示：微信登录用户，需补全用户信息再申请授权码</p>
      <el-form :rules="userInfoFormRules" :model="userInfoForm" ref="userInfoForm" class="reg-form" label-position="right"
               label-width="100px" auto-complete="off">
        <el-input type="password" style="position: fixed;bottom: -9999px"></el-input>

        <el-form-item prop="accountId" label="账户名：">
          <el-input placeholder="账户名" v-model="userInfoForm.accountId" class="login-id" disabled>
            <!-- <el-select v-model="form.role" slot="append" placeholder="账号类型" style="width: 107px">
              <el-option :key=1 label="个人用户" :value=1>
              </el-option>
              <el-option :key=2 label="企业用户" :value=2>
              </el-option>
            </el-select> -->
          </el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号：">
          <!-- <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16"> -->
            <el-input v-model="userInfoForm.mobile" auto-complete="off" placeholder="手机号" name="mobile" class="input-with-select">
              <el-select v-model="userInfoForm.countryMob" slot="prepend" placeholder="请选择" class="country-mobile-select">
                <el-option v-for="item in countryList" :key="item.value" :value="item.value">{{item.label}}&nbsp;&nbsp;{{item.value}}</el-option>
              </el-select>
            </el-input>
          <!-- </el-col> -->
          <!-- <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" class="sendBtn send-btn">
                  <smsCode :mobile="form.mobile" type="1" :countryMob="form.countryMob" :captcha="form.verifyCode" :captchaId="captchaId" @changeCaptcha="change"></smsCode>
          </el-col> -->
        </el-form-item>
        <el-form-item prop="email" label="邮箱：">
          <el-input class="col-md-12" type="text" v-model="userInfoForm.email"
                    placeholder="邮箱"></el-input>
        </el-form-item>

        <el-form-item label="地址：">
          <el-select  v-model="userInfoForm.provinceIndex" filterable placeholder="省份" @change="getCityList($event)" style="width: 49%;margin-right: 1%;">
            <el-option
              v-for="(item,index) in provinceList"
              :key="index"
              :label="item.province"
              :value="index">
            </el-option>
          </el-select>
          <el-select v-model="userInfoForm.cityIndex" filterable placeholder="城市" style="width: 50%">
            <el-option
              v-for="(item,index) in cityList"
              :key="index"
              :label="item.city"
              :value="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="company" label="公司名称：">
          <el-input class="col-md-12" type="text" v-model="userInfoForm.company" auto-complete="off"
                    placeholder="公司名称" name="company"></el-input>
        </el-form-item>
        <div style="display: flex;">
          <label class="reg-form-label">业务领域：</label>
          <div style="display: flex;width:calc(100% - 100px);justify-content: space-between;">
            <el-form-item  prop="busiScope" class="reg-form-item" style="width: 49%;">
              <el-select class="col-md-12" v-model="userInfoForm.busiScope" filterable placeholder="业务领域" style="width: 100%">
                <el-option
                  v-for="item in busiScopeList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item  prop="jobTitle" class="reg-form-item" style="width: 50%;">
              <el-select class="col-md-12" v-model="userInfoForm.jobTitle" filterable placeholder="岗位" style="width: 100%">
                <el-option
                  v-for="item in jobTitleList"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <el-form-item class="reg-form-item">
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-button type="primary" style="width: 100%" @click.native.prevent="supplementFn">提交</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import {Message} from "element-ui";
  
  const countryList = [
    {label: '中国/China', value: '+86'},
    {label: '中国香港/Hong Kong', value: '+852'},
    {label: '中国台湾/Taiwan', value: '+886'},
    {label: '中国澳门/Macao', value: '+853'},
    {label: '澳大利亚/Austria', value: '+61'},
    {label: '加拿大/Canada', value: '+1'},
    {label: '瑞士/Switzerland', value: '+41'},
    {label: '德国/Germany', value: '+49'},
    {label: '丹麦/Denmark', value: '+45'},
    {label: '法国/France', value: '+33'},
    {label: '英国/United Kingdom', value: '+44'},
    {label: '爱尔兰/Ireland', value: '+353'},
    {label: '意大利/Italy', value: '+39'},
    {label: '日本/Japan', value: '+81'},
    {label: '韩国/South Korea', value: '+82'},
    {label: '开曼群岛/Cayman Islands', value: '+1345'},
    {label: '马尔代夫/Maldives', value: '+960'},
    {label: '墨西哥/Mexico', value: '+52'},
    {label: '马来西亚/Malaysia', value: '+60'},
    {label: '荷兰/Netherlands', value: '+31'},
    {label: '挪威/Norway', value: '+47'},
    {label: '新西兰/New Zealand', value: '+64'},
    {label: '新加坡/Singapore', value: '+65'},
  ]

  export default {
    components: {},
    data() {
      return {
        loading: false,
        cloudSnProdItemList: [], //所有的计价规则
        commItemList: [], //通用计价规则
        partnerItemList: [], //行业伙伴计价规则
        form: {
          tag:'',
          serviceItemList:[],
          partnerFlag: false
        },
        rules: {
          tag: [{required: true, message: '请输入业务区分', trigger: 'blur'}, {max: 10, message: "长度在10个字符以内", trigger: 'blur'}],},
        //内容的整体高度class
        heightC: 'heightN0',
        //增值服务的开启数量
        extraCnt: 0,
        //行业伙伴的授权数量
        partnerSnCnt:0,
        inforSupplementVisible: false,        
        countryList: countryList,
        userInfoFormRules: {
          accountId: [{required: true, message: '请输入账户名', trigger: 'blur'},
            {max: 50, message: "长度在50个字符以内", trigger: 'blur'}],
          smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          email: [
            {required: true, message: '请输入邮箱', trigger: 'blur'},
            { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
          ],
          mobile: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
            {max: 16, message: "长度在16个字符以内", trigger: 'blur'},
            // {type: 'number', message: '请输入正确手机号', trigger: 'blur'}
          ],
          company: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
          busiScope: [{required: true, message: '请选择业务领域', trigger: 'blur'}],
          jobTitle: [{required: true, message: '请选择岗位', trigger: 'blur'}],
        },
        captchaId: '',
        userInfoForm: {
          accountId: '',
          mobile: '',
          email: '',
          // password: '',
          // verifyCode: '', //图片验证码
          // smsCode: '', //手机验证码
          role: 1,
          // confirmPassword:'',
          provinceIndex:'',
          cityIndex:'',
          company:'',
          busiScope:'',
          jobTitle:'',
          // source: '', // 渠道
          // term: '', // 关键词
          countryMob: '+86'
        },        
        busiScopeList:[
          "数字孪生",
          "教育教学",
          "展览展示",
          "游戏娱乐",
          "虚拟直播",
          "虚拟演出",
          "3D品牌营销",
          "数字藏品",
          "超写实数字人",
          "其他"
        ],
        jobTitleList:[
          "研发工程师",
          "研发负责人",
          "公司负责人",
          "部门负责人",
          "商务销售人员",
          "教师",
          "学生",
          "其他"
        ],
        provinceList:[],
        cityList:[],
      }
    },
    created() {
    },
    methods: {
      getProcProdItem: function () {
        this.getRequest('/pocPriceItem/list', {"type": 1}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cloudSnProdItemList = resp.data.result;

              this.commItemList = this.cloudSnProdItemList.filter(item => item.prodId == '876867839321964544');
              this.partnerItemList = this.cloudSnProdItemList.filter(item => item.prodId == '876867839321964545');
              this.commItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', false);
              })
              this.partnerItemList.forEach((item, index) => {
                this.$set(item, 'checkStatus', false);
              })
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      addSn: function () {
        var params = {};
        params.tag = this.form.tag;
        params.serviceItemList = this.user.partnerFlag && this.form.partnerFlag ? this.partnerItemList.filter(item => item.checkStatus)
          : this.commItemList.filter(item => item.checkStatus);

        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.$confirm('开发者平台申请授权码，并发数为2路，可用于营销演示、测试和集成功能。若平台运营者接入云渲染功能（并发高，规模大），可致电平行云专属客户经理。400-678-1024', '温馨提示', {
              confirmButtonText: '知道了',
              /*     cancelButtonText: '关闭',*/
              type: 'warning',
              center: true
            }).then(() => {
              this.loading = true;
              this.postRequestJson('/pocCloudSn/add', JSON.stringify(params)).then(resp => {
                this.loading = false;
                if (resp && resp.status == 200) {
                  var data = resp.data;
                  if (data.code == 1000) {
                    Message.success(data.message);
                    this.$router.replace({path: '/sn/index'});
                  } else {
                    Message.error(data.message);
                  }
                }
              });
            }).catch(() => {

            });

          }
        })
      },
      changeContentHeight:function(flag){
        if(flag){
          this.extraCnt += 1;
        }else {
          this.extraCnt -= 1;
        }
        this.heightC = 'heightN'+this.extraCnt;

      },
      getPartnerSnCnt:function () {
        var params = {};
        params.wm = "3";
        params.status = "0";
        params.page = 1;
        params.pageSize = 20;
        params.userId = this.user.userId
        this.getRequest('/pocCloudSn/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.partnerSnCnt = resp.data.result.total;
            }}});
      },
      getProvinceList(){
        this.getRequest('/uacLocationProvince/getProvinceList').then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.provinceList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      getCityList(event){
        this.getRequest('/uacLocationCity/getList',{'pid':this.provinceList[event].pid}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.cityList = resp.data.result;
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      supplementFn() {
        var _this = this;
        this.userInfoForm.mobile = this.userInfoForm.countryMob==='+86' ? this.userInfoForm.mobile : this.userInfoForm.countryMob + this.userInfoForm.mobile;

        var regPos = /^[0-9]+.?[0-9]*$/;
        if(regPos.test(this.userInfoForm.provinceIndex)){
          this.userInfoForm.province = _this.provinceList[this.userInfoForm.provinceIndex].province;
        }else {
          this.userInfoForm.province = this.userInfoForm.provinceIndex;
        }

        if(regPos.test(this.userInfoForm.cityIndex)){
          this.userInfoForm.city = _this.cityList[this.userInfoForm.cityIndex].city;
        }else {
          this.userInfoForm.city = this.userInfoForm.cityIndex;
        }
        const params = {
          ...this.userInfoForm,
          userId: this.user.userId
        }
        this.$refs['userInfoForm'].validate((valid) => {
          if (valid) {
            this.postRequestJson('/uacUser/update', JSON.stringify(params)).then(resp => {
              if (resp && resp.status == 200) {
                const data = resp.data;
                if (data.code == 1000) {
                  const result = Object.assign(data.result, {
                    token: this.user.token
                  });
                  this.$store.commit('login', result);
                  this.inforSupplementVisible = false;

                  // marketup表单数据采集
                  // this.submitFormToMarket(params);
                } else {
                  Message.error(data.message);
                }
              }
            });
          }
        })
      },
      submitFormToMarket(params) {
        const marketupWidget = new window._MARKETUP_CHAT.Widget({
          base: 'https://paraverse.marketup.cn',
        })
        if(marketupWidget) {
          const paramsObj = {
            _username: params.accountId,
            _mobile_phone: params.mobile,
            company_address: params.province + params.city,
            _company: params.company,
            business_type: params.busiScope, // 业务领域
            position: params.jobTitle   // 岗位
          }
          marketupWidget.submitFormData({websiteFormId:4370857068410881,data: paramsObj});
        }
      },
      inforSupplementClose() {
        if(!this.user.mobile){
          this.$router.push('/sn/index');
        }
      }
    },
    mounted: function () {
      if(!this.user.mobile){
        this.userInfoForm.accountId = this.user.accountId;
        window.history.pushState({ path: window.location.pathname+'?utm_source=weixinsaoma#/sn/add' }, '', window.location.pathname+'?utm_source=weixinsaoma#/sn/add');
        // this.$router.replace({
        //   path: '/sn/add',
        //   query: {
        //     // utm_source: 'weixinsaoma'
        //   }
        // })
        this.inforSupplementVisible = true;
        this.getProvinceList();
        // marketup埋点-----start
        const script = document.createElement('script');
        script.src = 'https://www.marketup.cn/resources/js/analytics.js';
        script.onload = () => {
          var analytics  = new window._MARKETUP_ANALYTICS.Analytics({base:'https://paraverse.marketup.cn',siteId:4364007118682113})
          analytics.page()
        };
        document.head.appendChild(script);
        const marketupScript_1 = document.createElement('script');
        marketupScript_1.type = 'text/javascript';
        marketupScript_1.src = 'https://www.marketup.cn/resources/js/floatingbar/floatingbar.js';
        document.body.appendChild(marketupScript_1);
        // marketup埋点-----end
      } 
      this.getProcProdItem();

      console.log(this.user.partnerFlag)
      //如果用户符合开通行业伙伴授权的权限，查询行业伙伴授权开通了多少个
      if(this.user.partnerFlag == '1'){
        this.getPartnerSnCnt();
      }
    }
    ,
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    beforeDestroy() {

    }
  }
</script>

<style scoped>
.sn-content .pxy-form-item .el-checkbox{
  float: none;
}
.box-card {
  text-align: left;
    border: 1px solid #EBEEF5;
    background-color: #FFF;
    color: #303133;
    border-radius: 4px;
    padding: 20px;

}
@media screen and (max-width: 768px) {
  /* 1px solid #EBEEF5 */
  .pxy-form-item .el-form-item__content .el-tag {
    height: auto!important;
    white-space: normal!important;
  }
  .pxy-form-item {
    margin-bottom: 10px!important;
    padding-bottom: 15px!important;
    box-sizing: border-box!important;
  }
  .pxy-form-item-line {
    border-bottom: 1px solid #EBEEF5!important;
  }
}

@media screen and (min-width: 769px) {
  .pxy-form-item .el-form-item__content {
    margin-left: 0!important;
  }
  .pxy-form-item .el-form-item__content .el-tag {
    margin-left: 10px!important;
  }
  .pxy-tag-label {
    display: inline-block;
  }
}
</style>
